import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';
import { FaRegFileAlt, FaArchive } from 'react-icons/fa';

import UserPhoto from '../../../../components/UserPhoto';
import Input from '../../../../components/Input';

export default function StudentsCard(props) {
    if (props.little) {
        return (
            <li className={"students-card little" + (props.coachMode ? " coach-mode" : "") + (props.selectToEmail ? " little-email" : "")}>
                {
                    props.selectToEmail ?
                    <Input
                        type="checkbox"
                        notShowPlaceholder
                        hideLabel
                        bold
                        checked={props.studentsSelectedToEmail[props.id]}
                        onChange={(e) => {
                            if(props.id in props.studentsSelectedToEmail) {
                                props.setStudentsSelectedToEmail(oldDict => {
                                    const temp = {...oldDict};
                                    delete temp[props.id];
                                    return temp;
                                })
                            }
                            else{
                                props.setStudentsSelectedToEmail(oldDict => {
                                    const temp = {...oldDict};
                                    temp[props.id] = 1;
                                    return temp;
                                })
                            }
                        }}
                    />
                    :
                    null

                }
                <UserPhoto src={props.src} alt='Foto de perfil do aluno' />
                <Link to={`/${props.coachMode ? "professor" : "academia"}/alunos/${props.id}`}>
                    <p className='name'><b>{props.name}</b></p>
                </Link>
                {/* <p className='class'><b>Turma:</b> {props.class}</p> */}
                {
                    props.coachMode ?
                        [] :
                        <button className={props.active ? 'delete' : 'green'} onClick={() => props.active ? props.onDisable() : props.onActivate()}><FaArchive /></button>
                }
            </li>
        )
    } else if (props.medium) {
        return (
            <li className={"students-card medium" + (props.coachMode ? " coach-mode" : "") + (props.selectToEmail ? " medium-email" : "")}>
                {
                    props.selectToEmail ?
                    <Input
                        type="checkbox"
                        notShowPlaceholder
                        hideLabel
                        bold
                        checked={props.studentsSelectedToEmail[props.id]}
                        onChange={(e) => {
                            if(props.id in props.studentsSelectedToEmail) {
                                props.setStudentsSelectedToEmail(oldDict => {
                                    const temp = {...oldDict};
                                    delete temp[props.id];
                                    return temp;
                                })
                            }
                            else{
                                props.setStudentsSelectedToEmail(oldDict => {
                                    const temp = {...oldDict};
                                    temp[props.id] = 1;
                                    return temp;
                                })
                            }
                        }}
                    />
                    :
                    null

                }
                <UserPhoto src={props.src} alt='Foto de perfil do aluno' />
                <Link to={`/${props.coachMode ? "professor" : "academia"}/alunos/${props.id}`}>
                    <p className='name'><b>{props.name}</b></p>
                </Link>
                <p className='id'><b>ID:</b> {props.id}</p>
                {
                    props.coachMode ?
                        <p className='age'><b>Idade:</b> {props.age}</p>
                        : []
                }
                <p className='class'><b>Turma:</b> {props.class}</p>
                {
                    props.coachMode ?
                        [] :
                        <>
                            <span className='documents'><p><FaRegFileAlt />{props.documents}</p></span>
                            {
                                props.scholarshipDueDate ?
                                    <p className='due-date'><b>Bolsa:</b> {props.scholarshipDueDate}</p>
                                    :
                                    <p className='due-date'>{props.dueDate ? <><b>Vencimento:</b> {props.dueDate}</> : <b></b>}</p>
                            }
                            <span className='status'>
                                <p
                                    className={
                                        props.status === "Pago" ?
                                            "paid" :
                                            (
                                                props.status === "Não pago" ?
                                                    "not-paid" :
                                                    (
                                                        props.status === "Bolsa" ?
                                                            "scholarship" :
                                                            "none"
                                                    )
                                            )
                                    }
                                >
                                    {props.status}
                                </p>
                            </span>
                            {/* <button className='edit' onClick={() => alert(`Edita ${props.name}`)}><FaPen /></button> */}
                            <button className={props.active ? 'delete' : 'green'} onClick={() => props.active ? props.onDisable() : props.onActivate()}><FaArchive /></button>

                        </>
                }
            </li>
        )
    } else {
        return (
            <li className={"students-card" + (props.coachMode ? " coach-mode" : "") + (props.selectToEmail ? " email" : "")}>
                {
                    props.selectToEmail ?
                    <Input
                        type="checkbox"
                        notShowPlaceholder
                        hideLabel
                        bold
                        checked={props.studentsSelectedToEmail[props.id]}
                        onChange={(e) => {
                            if(props.id in props.studentsSelectedToEmail) {
                                props.setStudentsSelectedToEmail(oldDict => {
                                    const temp = {...oldDict};
                                    delete temp[props.id];
                                    return temp;
                                })
                            }
                            else{
                                props.setStudentsSelectedToEmail(oldDict => {
                                    const temp = {...oldDict};
                                    temp[props.id] = 1;
                                    return temp;
                                })
                            }
                        }}
                    />
                    :
                    null

                }
                <UserPhoto src={props.src} alt='Foto de perfil do aluno' />
                <Link to={`/${props.coachMode ? "professor" : "academia"}/alunos/${props.id}`}>
                    <p className='name'><b>{props.name}</b></p>
                </Link>
                <p className='id'><b>ID:</b> {props.id}</p>
                <p className='age'><b>Idade:</b> {props.age}</p>
                <p className='class'><b>Turma:</b> {props.class}</p>
                {
                    props.coachMode ?
                        [] :
                        <>
                            <span className='documents'><p><FaRegFileAlt />{props.documents}</p></span>
                            {
                                props.scholarshipDueDate ?
                                    <p className='due-date'><b>Bolsa:</b> {props.scholarshipDueDate}</p>
                                    :
                                    <p className='due-date'>{props.dueDate ? <><b>Vencimento:</b> {props.dueDate}</> : <b></b>}</p>
                            }
                            <span className='status'>
                                <p
                                    className={
                                        props.status === "Pago" ?
                                            "paid" :
                                            (
                                                props.status === "Não pago" ?
                                                    "not-paid" :
                                                    (
                                                        props.status === "Bolsa" ?
                                                            "scholarship" :
                                                            "none"
                                                    )
                                            )
                                    }
                                >
                                    {props.status}
                                </p>
                            </span>
                            {/* <button className='edit' onClick={() => alert(`Edita ${props.name}`)}><FaPen /></button> */}
                            <button className={props.active ? 'delete' : 'green'} onClick={() => props.active ? props.onDisable() : props.onActivate()}><FaArchive /></button>
                        </>
                }
            </li >
        )
    }
}